import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative h-[640px] md:h-[700px] flex items-center overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20enterprise%20data%20center%20server%20room%20with%20racks%20and%20blue%20LED%20lighting%2C%20dark%20industrial%20interior%2C%20cinematic%20professional%20photography%2C%20shallow%20depth%20of%20field%2C%20subtle%20glow%20from%20network%20equipment%2C%20clean%20minimal%20composition%2C%20no%20people&width=1600&height=900&seq=hero-mitaja-1&orientation=landscape"
          alt="Enterprise infrastructure"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-900/70 to-primary-950/60"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/40 to-primary-950/80"></div>
      </div>

      <div className="relative z-10 container-page w-full">
        <div className="max-w-3xl">
          <p className="text-accent-300 text-sm font-semibold uppercase tracking-wider mb-4">
            Technology Services for Government & Enterprise
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6">
            Technology Expertise for Mission-Critical Environments
          </h1>
          <p className="text-lg md:text-xl text-foreground-300 leading-relaxed mb-10 max-w-2xl">
            Mitaja Corporation provides enterprise infrastructure and network engineering, database services, application and platform support, and specialized technology professionals for complex IT environments.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={() => { navigate("/capabilities"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="btn-primary bg-accent-500 hover:bg-accent-600 text-white"
            >
              Explore Our Capabilities
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <button
              onClick={() => { navigate("/markets"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="btn-secondary border-white/30 text-white hover:bg-white/10"
            >
              Government Contracting
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}